import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, InputCol, LevelRowContainer, MainWrapper, RoundedWrapper, Typeahead } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import FormTxt from 'components/atoms/Inputs/FormTxt';
import lo from 'lodash';
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { DateTimeInput } from 'components/molecules/DateTimeInput/index';
import { NewCargoLoaded } from 'fixtures/TemplateData';
import DataTable from 'components/organisms/DataTable/index';
import ButtonReg from 'components/atoms/Buttons/Button';
import { actionFormatter } from 'components/molecules/TableFormatters/actionFormatter';
import { selectFormatter } from 'components/molecules/TableFormatters/selectFormatter';
import { EditFormater } from 'components/molecules/TableFormatters/editFormatter';
import { getAllList } from 'services/cmsService';
import { BARGE_LOADING, BARGE_LOADING_HEADER, BELT_SCALE, LOADING_REQUEST } from 'fixtures/api';
import { getLookup } from 'Redux/actions/LookupActions';
import { getTunnelsData } from 'Redux/actions/TunnelsActions';
import moment from 'moment';
export class ActualLoadingHeaderForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      options: []
    }
  }

  componentDidMount(){
    this.fetchTugs()
    this.fetchLookup()
  }

  fetchLookup = () => {
    toggleIsLoading(true)
    const { getLookup, getTunnelsData } = this.props
    getLookup(BARGE_LOADING, BARGE_LOADING_HEADER)
    getTunnelsData()
    toggleIsLoading(false)
  }

  fetchTugs = async () => {
    try {
      const data = await getAllList(LOADING_REQUEST)
      this.setState({ options: data.map(d => ({...d, name: d.tug})) })
    } catch (error) {
      console.error(error);
    }
  }

  fetchBeltScale = async () => {
    try {
      const { form, onChange, toggleIsLoading } = this.props
      toggleIsLoading(true)
      const query = {
        tugboatName: form.tugName,
        loadingRequestId: form.loadingRequestId,
        loadingPlanId: form.loadingPlanId,
      }
      const searchParams = new URLSearchParams(lo.pickBy(query));
      const data = await getAllList(`${BELT_SCALE}${searchParams ? `?${searchParams.toString()}`: ''}`)
      if (data && data.tunnels) {
        const beltScales = data.tunnels.map((d) => ({
          tunnel: d.tunnelName,
          beltScale: d.tonnage,
        }))
        onChange('cargoLoaded', beltScales || [])
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  renderTugName(){
    const { form, onChange, onChangeForm } = this.props
    const tugs = form.tugName
    ? lo.values(lo.merge(lo.keyBy([{ name: form.tugName }], 'name'), lo.keyBy(this.state.options, 'name')))
    : this.state.options

    const onSelect = (val) => {
      if (val) {
        onChange('tugName', val)
      }
    }
    const onInputChange = (e) => {
      onChange('tugName', e)
    }
    const onClear = () => {
      form['bargeName'] = ''
      form['bargeSize'] = ''
      form['loadingRequestId'] = null
      form['loadingPlanId'] = null
      form['route'] = ''
      form['loadType'] = '-'
      form['coalQuality'] = ''
      form['noServicesTrip'] = ''
      onChangeForm(form)
    }
    return <InputCol>
      <Label lineheight={'14px'} size={'12px'}>
        Tug Name
      </Label>
      <Typeahead
        placeholder={'Select tug'}
        options={tugs}
        dispField={'name'}
        control={form.tugName ? [form.tugName] : []}
        onChangeVal={e => onSelect(e)}
        onInputChange={e => onInputChange(e)}
        onClearSelect={onClear}
      />
    </InputCol>
  }

  renderTextInput(label, key, placeholder, inputProps) {
    const { form, onChange, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }

    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormTxt
          placeholder={placeholder}
          mb={'16px'}
          value={form[key]}
          onChangeVal={e => onChange(key, e.target.value)}
          {...inputConfig}
          {...inputProps}
        />
      </InputCol>
    )
  }

  renderDateTimeInput(label, key) {
    const { form, onChange, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 25px',
      height: '34px',
      marginBottom: '16px'
    }

    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <DateTimeInput
          val={form[key] && new Date(form[key])}
          fn={(date, field) => onChange(field, moment(date).format())}
          field={key}
          showTime
          config={inputConfig}
        />
      </InputCol>
    )
  }

  renderPicker(label, key, placeholder, options, ...rest){
    const { form, onChange, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }
    return (
      <InputCol>
        <Label lineheight={'14px'} size={'12px'}>
          {label}
        </Label>
        <FormSelect
          placeholder={placeholder}
          onChangeVal={e => onChange(key, e.target.value)}
          options={options}
          value={form[key]}
          valField={'name'}
          dispField={'name'}
          arrowSize={'3%'}
          {...inputConfig}
          {...rest}
        />
      </InputCol>
    )
  }

  onChangeCargoLoaded(val, row, field, rowIndex) {
    const { form: { cargoLoaded }, onChange } = this.props
    const existing = cargoLoaded.map(d => d.tunnel).filter(d => d !== '-')
    if (existing.indexOf(val) > -1){
      return alert('Please choose another tunnel')
    }
    const newData = cargoLoaded.map((d,i) => {
      const newData = { ...row, [field] : val }
      if (i === rowIndex && (field === 'percentageLoading' || field === 'beltScale')){
        const { percentageLoading, beltScale } = newData
        const calculate = (Number(percentageLoading) / 100) * Number(beltScale)
        const newDraft = { ...newData, draft: `${Number(calculate).toFixed(3)}` }
        return newDraft
      } else {
        return i === rowIndex ? newData : d
      }
    })
    onChange('cargoLoaded', newData)
  }

  addCargoLoaded() {
    const { form: { cargoLoaded }, onChange } = this.props
    const newData = [...cargoLoaded, lo.cloneDeep(NewCargoLoaded)]
    onChange('cargoLoaded', newData)
  }

  onDeleteCargoLoaded(row, rowIndex) {
    const { form: { cargoLoaded }, onChange } = this.props
    const newData = cargoLoaded.filter((d,i) => i !== rowIndex)
    onChange('cargoLoaded', newData)
  }

  render() {
    const { lookups, form, viewState: { isMobileView } } = this.props

    const cargoLoadedConfig = [
      {
        dataField: 'tunnel',
        text: 'Tunnel',
        formatter: selectFormatter,
        formatExtraData: {
          placeholder: 'Select tunnel',
          options: lookups.tunnels || [],
          field: 'tunnel',
          valField: 'name',
          fn: (val, row, field, rowIndex) => this.onChangeCargoLoaded(val, row, field, rowIndex),
          allowEdit: true,
        },
        headerAttrs: { width: isMobileView ? 100 : 150 },
        editable: false,
        sort: true
      },
      {
        dataField: 'percentageLoading',
        text: 'Percentage Loading (%)',
        headerAttrs: { minWidth: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter percentage',
          type: 'number',
          field: 'percentageLoading',
          fn: (val, row, field, rowIndex) => this.onChangeCargoLoaded(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'beltScale',
        text: 'Belt (MT)',
        headerAttrs: { minWidth: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter belt',
          type: 'number',
          field: 'beltScale',
          fn: (val, row, field, rowIndex) => this.onChangeCargoLoaded(val, row, field, rowIndex),
        },
        sort: true
      },
      {
        dataField: 'draft',
        text: 'Draft (MT)',
        headerAttrs: { minWidth: 100 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Draft',
          type: 'text',
          field: 'draft',
          fn: (val, row, field, rowIndex) => this.onChangeCargoLoaded(val, row, field, rowIndex),
        },
        sort: true,
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { minWidth: 100 },
        formatter: actionFormatter,
        formatExtraData: {
          style: { height: '34px', display: 'flex', alignItems: 'center' },
          allowDel: true,
          del: (row, rowIndex) => this.onDeleteCargoLoaded.bind(this, row, rowIndex),
        },
        editable: false,
        isDummyField: true
      },
    ]

    return (
        <RoundedWrapper>
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Barge Loading
              </Label>
            </HeadContainer>
            <LevelRowContainer isTop>
              {this.renderTextInput('No Ref Report', 'noRefReport', '', { disabled: true } )}
              {this.renderPicker('Site', 'site', 'Select site', lookups.site || [] )}
              {this.renderTextInput('No Service Trip', 'noServicesTrip', 'Enter no. service trip' )}
              {this.renderTugName()}
            </LevelRowContainer>
            <LevelRowContainer>
              {this.renderTextInput('Barge Name', 'bargeName', 'Enter barge name')}
              {this.renderTextInput('Barge Size (FT)', 'bargeSize', 'Enter barge size')}
              {this.renderTextInput('Route', 'route', 'Enter route')}
              {this.renderPicker('Load Type', 'loadType', 'Select load type', lookups.loadTypes || [] )}
            </LevelRowContainer>
            <LevelRowContainer>
              {this.renderDateTimeInput('Arrival Time', 'arrivalTime')}
              {this.renderDateTimeInput('Invalid Draft, Hold Cleanless', 'initialDraft')}
              {this.renderDateTimeInput('Anchor Up', 'anchorUp')}
              {this.renderDateTimeInput('Berthed Time', 'berthedTime')}
            </LevelRowContainer>
            <LevelRowContainer>
              {this.renderDateTimeInput('Commenced Loading', 'commencedLoading')}
              {this.renderDateTimeInput('Completed Loading', 'completedLoading')}
              {this.renderDateTimeInput('Unberthing', 'unberthing')}
              {this.renderDateTimeInput('Depature', 'departure')}
            </LevelRowContainer>
            <LevelRowContainer>
              {this.renderTextInput('Coal Quality / Specs', 'coalQuality', 'Enter coal quality')}
              {this.renderTextInput('Surveyor Name', 'surveyorName', 'Enter surveyor name')}
            </LevelRowContainer>
            <LevelRowContainer>
              {this.renderPicker('Delay Cause of Barge Changing', 'delayCause', 'Select delay cause', lookups.delayCauses || [] )}
              {this.renderPicker('Delay Cause During Process Berthing', 'delayCauseDuringBerthing', 'Select delay cause', lookups.delayCausesBerthing || [] )}
            </LevelRowContainer>
            <LevelRowContainer className="row col-6 offset-6 mx-0">
              {this.renderTextInput('Water Level During Loading (Meter)', 'waterLevelDuringLoading', 'Enter water level')}
            </LevelRowContainer>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Cargo Loaded
              </Label>
            </HeadContainer>
              <LevelRowContainer>
                <DataTable
                  leftSlot={
                    <>
                      <ButtonReg
                        btnTxt={'Add'}
                        onClick={() => this.addCargoLoaded()}
                        width={'78px'}
                      />
                      <ButtonReg
                        bordered
                        transparent
                        margin="0 0 0 10px"
                        btnTxt={'Refresh Beltscale'}
                        onClick={() => this.fetchBeltScale()}
                        width={'150px'}
                      />
                    </>
                  }
                  allowSearch={false}
                  rightSlotAlt={true}
                  defaultSize={100}
                  isMobile={isMobileView}
                  dataList={form.cargoLoaded || []}
                  columnConfig={cargoLoadedConfig}
                />
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  lookups.site = lo.uniqBy(state.userLogin.userDetail.allowedCompanies.map((d) => ({ name: d.workLocation.name })),
  'name',
  )
  lookups.loadTypes = [{ name: 'Trans Shipment' },{ name: 'Direct Shipment' }]
  if (state.lookups.data && state.lookups.data.BARGE_LOADING) {
    const bargeLoading = state.lookups.data.BARGE_LOADING
    const delayCauses = bargeLoading.BARGE_LOADING_HEADER && bargeLoading.BARGE_LOADING_HEADER.find((d) => d.name === 'DELAY_CAUSE_OF_BARGE_CHANGING')
    lookups.delayCauses = delayCauses ? delayCauses.children.map((d) => ({ name: d.nameDisplay })) : []
    const delayCausesBerthing = bargeLoading.BARGE_LOADING_HEADER && bargeLoading.BARGE_LOADING_HEADER.find((d) => d.name === 'DELAY_CAUSE_DURING_PROCESS_BERTHING')
    lookups.delayCausesBerthing = delayCausesBerthing ? delayCausesBerthing.children.map((d) => ({ name: d.nameDisplay })) : []
  }
  lookups.tunnels = state.tunnels ? state.tunnels.map((d) => ({ name: d.tunnelName })) : []
  return {
    viewState: state.viewState,
    lookups,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup,
      getTunnelsData
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingHeaderForm)
  )
);
